import React from "react";
import Box from "@mui/material/Box";

import { useThemeContext } from "../../contexts/ThemeContext";
import { useColumnVisibilityContext } from "./contexts/ColumnVisibilityContext";
import { CurrentGroupProvider } from "./contexts/CurrentGroupContext";
import { ColumnVisibilityProvider } from "./contexts/ColumnVisibilityContext";
import { ShowCreateGroupProvider } from "./contexts/ShowCreateGroupContext";

import Groups from "./views/Groups/Groups";
import Messages from "./views/Messages/Messages";
import Actions from "./views/Actions/Actions";

// Define the type for props
interface ChatProps {
  handleClose: () => void;
}

const ChatInner: React.FC<ChatProps> = ({ handleClose }) => {
  const { theme } = useThemeContext();
  const { leftColumnVisible, middleColumnVisible, rightColumnVisible } =
    useColumnVisibilityContext();

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {leftColumnVisible && (
        <Groups
          handleClose={handleClose}
          sx={{
            flex: 1,
            borderRight: `1px solid ${theme === "dark"
              ? "rgba(255, 255, 255, 0.12)"
              : "rgba(0, 0, 0, 0.12)"
              }`,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        />
      )}
      {middleColumnVisible && (
        <Messages
          sx={{
            flex: 3,
            borderRight: `1px solid ${theme === "dark"
              ? "rgba(255, 255, 255, 0.12)"
              : "rgba(0, 0, 0, 0.12)"
              }`,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            background:
              theme === "dark"
                ? "linear-gradient( rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8) ), url(../img/background2.png)"
                : "linear-gradient( rgba(255, 255, 255, 0.01), rgba(255, 255, 255, 0.01) ), url(../img/background2.png)",
          }}
        />
      )}
      {rightColumnVisible && (
        <Actions
          sx={{
            flex: 1,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        />
      )}
    </Box>
  );
};

// This is your exported component with providers wrapped
const ChatWithProviders: React.FC<ChatProps> = ({ handleClose }) => (
  <CurrentGroupProvider>
    <ColumnVisibilityProvider>
      <ShowCreateGroupProvider>
        <ChatInner handleClose={handleClose} />
      </ShowCreateGroupProvider>
    </ColumnVisibilityProvider>
  </CurrentGroupProvider>
);

export default ChatWithProviders;